import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import AreaExposicao from '../AreaExposicao';
import AreaInstitucional from '../AreaInstitucional';
import { ContactIcons, scrollTo, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';




import { usePages } from '../../hooks/Pages';

import SponsorsList from '../Sponsors';

import { usePlatformData } from '../../hooks/Platform';
import ContagemRegressiva from '../../components/ContagemRegressiva';
import Program from '../../components/Program';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Home: React.FC = () => {
  const {platform} = usePlatformData();
  return (
    <>
      <Capa>
        <div className="p50">
       <div style={{width: '100%', display: 'flex', flexWrap: 'wrap', alignContent: 'center', justifyContent: 'center'}}>
          
       <div style={{ maxWidth: '600px',width: '100%'}}>
         <h1 style={{fontSize: '38px'}}>Encontro de Produtores Alianza del Pastizal – BR</h1>
         <h2 style={{fontSize: '20px'}}>29 de outubro de 2021</h2>
         <p><br/>
         <strong>Local do evento: </strong><br/>Pavilhão no Parque de Exposições em Lavras do Sul<br/>
R. Dr. Píres Pôrto, 240
<br/>
<br/>De acordo com o Decreto estadual de 01/10/2021, para ingresso presencial ao evento é obrigatória a apresentação do comprovante de vacinação oficial (Conecte SUS ou Carteira de Vacinação) de acordo com o calendário de vacinação estadual.
<br/>
<br/>  Acima de 40 anos: sistema vacinal completo
<br/>  De 18 a 39 anos: 1ª dose

         </p>
         <div style={{width:'100%', margin: '20px auto', display:'flex', alignItems: 'center', justifyContent:'center'}}>
         <ContagemRegressiva dataDesejada="2021-10-29T08:45:00-03:00" />
         </div>
          </div>
   
        
        </div>
        {platform?.homeTitle && <h2 className="defaultColor">{platform?.homeTitle}</h2>}
        {platform?.homeDescription && <p className="defaultColor" dangerouslySetInnerHTML={{__html: platform?.homeDescription}}/>}
          <div
            className=""
            style={{
              width: '100%',

              marginBottom: '20px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >

<Link className="" to={'/inscricao'}>
              <Button type="button">Inscrição</Button>
{' '}
            </Link>
     <Link className="" to={'/login'}>
              <Button type="button">Acessar</Button>
{' '}
            </Link>


          </div>
     
          <img src="/apoio/sponsors.png" style={{ width: '100%'}}/>
        </div>

     
      </Capa>


      <Capa>
        <Program/>
      </Capa>
      <Capa style={{flexDirection:'column'}}>
        <h1>Temáticas do evento</h1>

        <table className="table">
           <tr><td>Atualização das ações Alianza del Pastizal e Planejamento 2022</td></tr>
           <tr><td>Estratégia de controle de invasoras exóticas (Capim-annoni e Javali): Pró-APA sustentável</td></tr>
           <tr><td>Manejo e melhoramento de campo nativo</td></tr>
           <tr><td>Gestão e planejamento de sistemas pecuários</td></tr>
           <tr><td>Acesso à crédito - Plano ABC</td></tr>
           <tr><td>Levantamento de aves</td></tr>
           <tr><td>Oportunidade de agregação de valor em produtos do bioma Pampa</td></tr>
           <tr><td>Pecuária sustentável e o mercado para o futuro</td></tr>
        </table>
      </Capa>
    </>
  );
};
export default Home;
